// One open referee invitation: its terms and the referee's answer. Declining
// asks first, since only the organizers can invite again. A deleted
// tournament's invitation can only be declined, and without asking

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Spinner from './Spinner';
import { useModal } from './ModalProvider';
import { tournamentRefereeRespond } from '../utils/firebase';
import { moneyStr } from '../utils/gameReport';
import './RefereeInvitation.scss';

export default function RefereeInvitation({
  entry,
  tournamentName,
  isDeleted,
}) {
  const [spinner, setSpinner] = useState(false);
  const { openModal } = useModal();

  const respond = async (accept) => {
    setSpinner(true);
    try {
      // The offer on screen: a re-invitation rewrites invitedAt, and the
      // backend refuses an answer to an offer since changed
      await tournamentRefereeRespond({
        id: entry.tournamentId,
        accept,
        fee: entry.fee,
        invitedAt: entry.invitedAt.toMillis(),
      });
      toast.success(accept ? 'Invitation accepted' : 'Invitation declined');
    } catch (error) {
      toast.error(error?.message ?? 'Failed to answer the invitation');
    } finally {
      setSpinner(false);
    }
  };

  const decline = () =>
    openModal({
      header: 'Decline invitation',
      body: (
        <p className='font-16'>
          Decline refereeing{' '}
          <span className='font-medium'>
            {tournamentName ?? 'this tournament'}
          </span>
          ? Only the organizers can invite you again.
        </p>
      ),
      buttons: [
        { text: 'Cancel', className: 'bw' },
        { text: 'Decline', className: 'danger', onClick: () => respond(false) },
      ],
    });

  return (
    <div className='referee-invitation'>
      {isDeleted ? (
        <p className='font-medium'>This tournament was deleted</p>
      ) : tournamentName ? (
        <Link to={`/tournaments/${entry.tournamentId}`} className='font-medium'>
          {tournamentName}
        </Link>
      ) : (
        <p className='font-medium'>You're invited to referee this tournament</p>
      )}
      <p>
        Fee: <span className='font-medium'>{moneyStr(entry.fee ?? 0)}</span> per
        game
      </p>
      {entry.requirements && (
        <p className='requirements'>{entry.requirements}</p>
      )}
      <div className='btns-wrap'>
        <button
          className='small bw'
          onClick={isDeleted ? () => respond(false) : decline}
          disabled={spinner}
        >
          Decline
        </button>
        {!isDeleted && (
          <button
            className='small'
            onClick={() => respond(true)}
            disabled={spinner}
          >
            Accept
          </button>
        )}
      </div>
      <Spinner show={spinner} />
    </div>
  );
}
